import * as React from 'react';
import {saveAs} from 'file-saver';

interface QRCodeDownloadableProps {
    src: string,
    filename: string
}

class QRCodeDownloadable extends React.Component <QRCodeDownloadableProps, {}> {
    public constructor(props: QRCodeDownloadableProps) {
        super(props);
        this.clickDownload = this.clickDownload.bind(this);
    }

    public clickDownload(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        const data = this.props.src.split(',');
        const byteStr = atob(data[1].replace(/\s/g, ''));
        const ab = new ArrayBuffer(byteStr.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteStr.length; i++) {
            ia[i] = byteStr.charCodeAt(i);
        }
        const mimeStr = data[0].split(':')[1].split(';')[0];
        const blob = new Blob([ab], {type: mimeStr});
        try {
            saveAs(blob, this.handleFilename(this.props.filename));
        } catch(error) {
            window.navigator.msSaveBlob(blob, this.handleFilename(this.props.filename));
        }
    }

    public render() {
        return (
            <button className="cmHorCenter" onClick={this.clickDownload}>
                <img className="cmQrCode" src={this.props.src}/>
            </button>
        );
    }

    private handleFilename(filename: string) {
        const split = filename.split('.');
        const name = split[0];
        if (name === '')
            split[0] = 'midas';
        if (split.length === 1)
            return `${name}.png`;

        const ext = split[-1];
        if (ext === '')
            split[-1] = 'png';
        return split.join('.');
    }
}

export default QRCodeDownloadable;



// WEBPACK FOOTER //
// ./src/Components/Custom/QRCodeDownloadable.tsx